<script lang="ts">
    import { Label } from "sveltestrap";
    import {disableswitch} from "../../../../Data/Forms/Widgets/Widgets"
</script>

{#each disableswitch as switchItem}
  <div class="media">
    <Label class="col-form-label m-r-10">{switchItem.title}</Label>
    <div class="media-body text-end {switchItem.class}">
      <Label class="switch">
        <input type="checkbox" disabled /><span class="switch-state" />
      </Label>
    </div>
  </div>
{/each}
